import { Category } from "~/models/Category";
import { CategorySectionModel } from "~/models/CategorySection";

export const useApiCategories = async () => {
  const categorySection = new CategorySectionModel();

  try {
    const resCategories = await useFetchGet<ResponseCategory[]>(
      "contents/categories",
    );
    for (const category of resCategories) {
      categorySection.addCategory(
        new Category(category.id, category.image, category.title),
      );
    }
    return categorySection.getCategories();
  } catch (_) {
    return categorySection.getCategories();
  }
};
